import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

export default function CampaignRedirect() {
  const { code }   = useParams();
  const navigate   = useNavigate();
  useEffect(() => {
    navigate(`/clicktowin?ref=${(code || "").toUpperCase()}`, { replace: true });
  }, [code, navigate]);
  return null;
}
